import React from "react";
import { LuCalendar } from "react-icons/lu";

import Button from "../ui/Button";
import Input from "../ui/Input";
import cx from "../ui/cx";
import {
  buttonSpinnerClass,
  cardClass,
  cardContentClass,
  cardHeaderClass,
  fieldIconClass,
  fieldInputClass,
  filterFooterClass,
  filterGridClass,
  filterLabelClass,
  filterTitleClass,
  segmentActiveClass,
  segmentButtonClass,
  segmentInactiveClass,
} from "../ui/styles";
import { BusinessReportFilterProps } from "../../types/businessReport";

export const reportPresets = [
  { key: "today", label: "આજે" },
  { key: "thisMonth", label: "આ મહિનો" },
  { key: "lastMonth", label: "ગયો મહિનો" },
  { key: "financialYear", label: "આ નાણાકીય વર્ષ" },
];

const presetTrackClass =
  "grid grid-cols-2 items-center gap-1 rounded-lg bg-gray-100 p-1 sm:inline-flex";

type Props = {
  filter: BusinessReportFilterProps;
  activePreset: string | null;
  canExport: boolean;
  isLoading: boolean;
  isExporting: boolean;
  onChange: (value: Partial<BusinessReportFilterProps>) => void;
  onPreset: (preset: string) => void;
  onApply: () => void;
  onReset: () => void;
  onExport: () => void;
};

const BusinessReportFilter = ({
  filter,
  activePreset,
  canExport,
  isLoading,
  isExporting,
  onChange,
  onPreset,
  onApply,
  onReset,
  onExport,
}: Props) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onApply();
  };

  return (
    <div className={cardClass}>
      <div className={cardHeaderClass}>
        <div className={filterTitleClass}>ફિલ્ટર</div>
      </div>

      <div className={cardContentClass}>
        <div className="mb-4">
          <div className={presetTrackClass}>
            {reportPresets.map((preset) => (
              <button
                key={preset.key}
                type="button"
                onClick={() => onPreset(preset.key)}
                className={cx(
                  segmentButtonClass,
                  activePreset === preset.key
                    ? segmentActiveClass
                    : segmentInactiveClass
                )}
              >
                {preset.label}
              </button>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={filterGridClass}>
            <div className="space-y-2">
              <label className={filterLabelClass}>તારીખ થી</label>
              <div className="relative">
                <LuCalendar className={fieldIconClass} />
                <Input
                  type="date"
                  className={fieldInputClass()}
                  value={filter.fromDate}
                  onChange={(e) => onChange({ fromDate: e.target.value })}
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className={filterLabelClass}>તારીખ સુધી</label>
              <div className="relative">
                <LuCalendar className={fieldIconClass} />
                <Input
                  type="date"
                  className={fieldInputClass()}
                  value={filter.toDate}
                  onChange={(e) => onChange({ toDate: e.target.value })}
                />
              </div>
            </div>
          </div>

          <div className={cx(filterFooterClass, "flex-wrap")}>
            <Button
              type="button"
              variant="outline"
              className="max-sm:flex-1"
              onClick={onReset}
              disabled={isLoading}
            >
              ફિલ્ટર સાફ કરો
            </Button>

            {canExport && (
              <Button
                type="button"
                variant="primary"
                className="max-sm:flex-1"
                onClick={onExport}
                disabled={isExporting}
              >
                {isExporting && <span className={buttonSpinnerClass} />}
                રિપોર્ટ બનાવો
              </Button>
            )}

            <Button
              type="submit"
              variant="primary"
              className="max-sm:flex-1"
              disabled={isLoading}
            >
              ફિલ્ટર લાગુ કરો
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default BusinessReportFilter;
